import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { AveriasService } from '../servicios/averias.service';
import { Origen } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';

@Component({
    selector: 'app-origen',
    templateUrl: './origen.component.html',
    styleUrls: ['./origen.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule,SpinnerComponent,AngularSlickgridModule,NbTabsetModule],
})
export class OrigenComponent implements OnInit {
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  checked = false;
  origen;
  IdOrigen: number;
  origenOK = false;
  origenProcesado;
  descripcionOrigen;
  descripcionBreve;
  codigoExterno;
  clienteId;
  origenCompleto;
  descripcionBreveEditar;
  descripcionOrigenEditar;
  codigoExternoEditar;
  loadingResponseOrigen = false;
  datasetOrigen: any[] = [];
  datasetOrigenConsulta: any[] = [];
  angularGridOrigen: AngularGridInstance;
  angularGridOrigenConsulta: AngularGridInstance;
  showSpinner = false;
  cargarGrillaOrigen = false;
  columnDefinitionsOrigen: Column[];
  columnDefinitionsOrigenConsulta: Column[];
  gridOptionsOrigen: GridOption;
  gridOptionsOrigenConsulta: GridOption;
  gridObjOrigen: any;
  showGrilla = false;
  showGrillaConsulta = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  showSpinnerConsulta = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  showGrillaModificar = false;
  showSpinnerModificarGrilla = false;
  columnDefinitionsOrigenModificar: Column[];
  gridOptionsOrigenModificar: GridOption;
  datasetOrigenModificar: any[] = [];
  angularGridOrigenModificacion: AngularGridInstance;
  

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, private _snackBar: MatSnackBar, private dateFormatter:DatePipe,public usersRol: PerfilesUsuarioService) { }
  ngOnInit(): void {
    this.idCliente = Number( localStorage.getItem("idCliente"));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });

  }

  ngAfterViewInit():void {
    
  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarOrigen();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarOrigenConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarOrigenModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarOrigen() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getOrigen(this.idCliente ).subscribe(
      data => {
        this.origenCompleto = data;
        this.origen = this.insertarOrigen(data);
        this.traerDatosOrigen();
        this.fillGrillaOrigen();
      });
  }
  consultarOrigenConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getOrigen(this.idCliente ).subscribe(
      data => {
        this.origenCompleto = data;
        this.traerDatosOrigenConsulta();
        this.fillGrillaOrigenConsulta();
      });
  }
  consultarOrigenModificar() {
    this.showSpinnerModificarGrilla = true;
    this.showGrillaModificar = false
    this.AveriasService.getOrigen(this.idCliente ).subscribe(
      data => {
        this.origenCompleto = data;
        this.origen = this.insertarOrigen(data);
        this.traerDatosOrigenModificar();
        this.fillGrillaOrigenModificar();
      });
  }
  insertarOrigen(armarOrigen) {
    let averiasOrigen: Array<any> = [];
    armarOrigen.content.forEach(element => {
      averiasOrigen.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasOrigen;
  };
  capturarOrigen(event) {
    this.IdOrigen = event;
    this.origenOK = true;
  }
  altaOrigen() {
    let origen: Origen;

    if (this.descripcionOrigen == null || this.descripcionOrigen == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else {
      origen = {
        descripcion: this.descripcionOrigen,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idCliente: this.idCliente
      }
      this.AveriasService.postOrigen(origen).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.descripcionOrigen = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.consultarOrigen();
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarOrigen() {
    let origen: Origen ; 

    if (this.eliminar) {
      this.AveriasService.deleteOrigen(this.origenProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionOrigenEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.origenProcesado = '';
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarOrigenModificar();
      })
    } else {
      if (this.descripcionOrigenEditar == null || this.descripcionOrigenEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        origen = {
          descripcion: this.descripcionOrigenEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idCliente: this.idCliente,
      }
      this.AveriasService.putOrigen(this.origenProcesado, origen).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
          // this.consultarOrigen();
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarOrigenModificar();
      })
      this.descripcionOrigenEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.origenProcesado = '';
      this.eliminarSeleccionado = false;
    }
    }
  }
  obtenerDescripcionDropdown(IdOrigen: number) {
    let resp = this.origenCompleto.content.find(n => n['id'] == IdOrigen);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionOrigenEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
  }
  //Grilla Origen
  traerDatosOrigen() {
    this.loadingResponseOrigen = true;
    let DatosOrigen = this.origenCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosOrigen.length; i++) {
      mockDataset.push({
        id: DatosOrigen[i]["id"],
        Descripcion: DatosOrigen[i]["descripcion"],
        DescripcionAbreviada: DatosOrigen[i]["descripcionAbreviada"],
        Codigo: DatosOrigen[i]["codigoExterno"],
      });
    }
    this.datasetOrigen  = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;

  }

  traerDatosOrigenConsulta() {
    let DatosOrigen = this.origenCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosOrigen.length; i++) {
      mockDataset.push({
        id: DatosOrigen[i]["id"],
        Descripcion: DatosOrigen[i]["descripcion"],
        DescripcionAbreviada: DatosOrigen[i]["descripcionAbreviada"],
        Codigo: DatosOrigen[i]["codigoExterno"],
      });
    }
    this.datasetOrigenConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;

  }

  traerDatosOrigenModificar() {
    let DatosOrigen = this.origenCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosOrigen.length; i++) {
      mockDataset.push({
        id: DatosOrigen[i]["id"],
        Descripcion: DatosOrigen[i]["descripcion"],
        DescripcionAbreviada: DatosOrigen[i]["descripcionAbreviada"],
        Codigo: DatosOrigen[i]["codigoExterno"],
      });
    }
    this.datasetOrigenModificar  = mockDataset;
    this.showSpinnerModificarGrilla = false;
    this.showGrillaModificar = true;

  }
  fillGrillaOrigen() {
    this.columnDefinitionsOrigen = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 40, width: 40,},
    ];
    this.gridOptionsOrigen = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaOrigenConsulta() {
    this.columnDefinitionsOrigenConsulta = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 40, width: 40,},
    ];
    this.gridOptionsOrigenConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaOrigenModificar() {
    this.columnDefinitionsOrigenModificar = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 40, width: 40,},
    ];
    this.gridOptionsOrigenModificar = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  angularGridReadyOrigen(angularGrid: AngularGridInstance){
    this.angularGridOrigen = angularGrid;
    this.angularGridOrigen.resizerService.pauseResizer(false)
  }

  angularGridReadyOrigenConsulta(angularGrid: AngularGridInstance){
    this.angularGridOrigenConsulta = angularGrid;
    this.angularGridOrigenConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyOrigenModificar(angularGrid: AngularGridInstance){
    this.angularGridOrigenModificacion = angularGrid;
    this.angularGridOrigenModificacion.resizerService.pauseResizer(false)
  }


  exportToExcelOrigen() {
    (this.angularGridOrigenConsulta as any).excelExportService.exportToExcel({
      filename: 'Origen_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
      format: FileType.xlsx
    });
  }
}
